import { render, staticRenderFns } from "./ConsentPrompt.vue?vue&type=template&id=0d9c204a&"
import script from "./ConsentPrompt.vue?vue&type=script&lang=js&"
export * from "./ConsentPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports